/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */

import cx from 'classnames';
import styled from 'styled-components';

import { device } from 'helpers/screenSizes';
import PopoverWithCustomIcon from 'UIKit/PopoverWithCustomIcon';

const Title = styled.div`
  width: fit-content;
  border-bottom: 1px dashed var(--main-text-secondary);
  cursor: pointer;

  @media ${device.up.md} {
    &:hover {
      border-bottom: 1px dashed var(--brand-border-primary);
    }
  }
`;

const Body = styled.div`
  background: var(--tooltipInfoBoxColor);
  box-shadow: 0px 9px 18px rgb(0 0 0 / 15%);
  border-radius: 2px;
  color: var(--tooltipInfoBoxfontColor);
  padding: 10px 12px 10px 15px;
  max-width: 340px;
  font-size: 12.1px;
  line-height: 1.68;
  font-family: var(--fontLight);
  letter-spacing: 0.6px;
  white-space: normal;
  word-wrap: break-word;
  @media ${device.down.md} {
    width: 100%;
    // left: -40px;
    top: 5px;
    position: relative;
  }
`;

const Tooltip = props => {
  const {
    title,
    body,
    bodyClass,
    titleClass,
    transformOrigin,
    anchorOrigin,
    isTopLevelContainer,
    parentDivStyle,
    getTooltipStatus,
    customStyles,
    'data-testid': testId,
  } = props;

  const defaultTestId = 'tooltip';
  return (
    <PopoverWithCustomIcon
      getTooltipStatus={getTooltipStatus}
      dataTestId={testId || title}
      iconComponent={
        <Title
          data-testid={`${testId || defaultTestId}-title`}
          className={cx('customIconTooltipTitle', titleClass)}
        >
          {title}
        </Title>
      }
      popoverComponent={
        <Body
          data-testid={`${testId || defaultTestId}-body`}
          className={cx('customIconTooltipBody', bodyClass)}
        >
          {body}
        </Body>
      }
      transformOrigin={
        transformOrigin || {
          vertical: 'top',
          horizontal: 'left',
        }
      }
      anchorOrigin={
        anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'left',
        }
      }
      isTopLevelContainer={isTopLevelContainer}
      parentDivStyle={parentDivStyle}
      styles={customStyles}
    />
  );
};

export default Tooltip;
